import { ChangeDetectionStrategy, Component, inject, Input, input, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FairFormService } from 'src/app/components/fair-form/fair-form.service';

@Component({
    selector: 'app-fair-form',
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule
    ],
    templateUrl: './fair-form.component.html',
    styleUrl: './fair-form.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FairFormComponent {
  readonly #fairFormService = inject(FairFormService);

  @Input({ required: true }) redirect!: string;

  readonly form = new FormGroup({
    name: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    phone: new FormControl('', { nonNullable: true, validators: [Validators.required] })
  });

  submit() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.#fairFormService.submit(this.form.value)
        .subscribe(() => {
          window.location.href = this.redirect;
        });
    }
  }
}
